import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { boxWrapperRoundness } from 'styles/global';

export interface IBoxProps {
  className?: string;
  dataTestId?: string;
  elevation?: string;
  children?: ReactNode;
  onClick?: () => void;
}

const Box = ({ className, dataTestId, elevation, children, ...rest }: IBoxProps) => {
  return (
    <StyledBox
      className={className}
      data-testid={dataTestId || 'box'}
      depth={elevation}
      {...rest}
    >
      {children}
    </StyledBox>
  );
};

export default Box;

const StyledBox = styled.div<{ depth?: string }>`
  height: fit-content;
  ${boxWrapperRoundness};
  box-shadow: ${({ theme, depth }) =>
    depth ? theme.elevation[depth] : 'rgba(0, 0, 0, 0.04) 0px 0px 24px'};
  background-color: ${({ theme }) => !theme.view.isSdk && theme.colors.white};
`;
